module.exports = __webpack_public_path__ + "img/pt_br.d3619a21.png";